module.exports = __webpack_public_path__ + "static/img/mastercard_payment.4251d4bb.png";